// 评论池按首尾去空白后的完整文案去重，保留首次出现顺序和内部文本。
export function normalizeReviewRows(rows) {
  const seen = new Set()
  return rows.reduce((result, row) => {
    const value = row.value == null ? '' : String(row.value).trim()
    if (value && !seen.has(value)) {
      seen.add(value)
      result.push({ ...row, value })
    }
    return result
  }, [])
}
